import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {Pressable, TabItem} from "@hosttools/frontend/components";
import React, {memo, useCallback, useEffect} from "react";

import Text from "../Text";

import type {TabVariant} from "./type";

type Props = {
    id: string;
    isActive: boolean;
    title: string;
    variant: TabVariant;
    onClick: (id: string) => void;
};

const style = tva({
    base: "pb-7 border-b-[3px] border-solid select-none",
    variants: {
        isActive: {
            true: "border-blue-600",
            false: "border-transparent"
        }
    }
});

const TabButton: React.FC<Props> = ({id, title, variant, onClick, isActive}) => {
    const tabRef = React.useRef<HTMLButtonElement>(null);

    const handleClickTab = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    useEffect(() => {
        if (isActive) {
            tabRef.current?.scrollIntoView({behavior: "smooth", block: "nearest"});
        }
    }, [isActive]);

    if (variant === "buttonGroup") {
        return (
            <TabItem className="flex-1" id={id} onPress={handleClickTab}>
                {title}
            </TabItem>
        );
    }

    if (variant === "tab") {
        return (
            <Pressable<"web">
                ref={tabRef}
                className={style({isActive})}
                testID="tab-item"
                onPress={handleClickTab}
            >
                <Text color="blueGray.800" userSelect={false} variant="sm">
                    {title}
                </Text>
            </Pressable>
        );
    }

    return null;
};

export default memo(TabButton);
